// Google Workspace 監査カタログ（A〜E の監視カテゴリ）の正本。frontend/backend 両方から参照する。
// 実 Directory/Bedrock 連携は audit/ 層 — このファイルはデータ定義のみ。
import rawCatalog from "./catalog.json";

export type GwSeverity = "critical" | "high" | "medium" | "low";
export type GwCheckCategory =
  | "account-2sv"
  | "user-hygiene"
  | "group-sharing"
  | "third-party-apps"
  | "login-anomaly";

export interface GwCheck {
  readonly id: string;
  readonly category: GwCheckCategory;
  readonly title: string;
  readonly what: string;
  readonly why: string;
  readonly severity: GwSeverity;
  readonly remediation: string;
}

export interface GwCategoryDef {
  readonly key: GwCheckCategory;
  readonly label: string;
  readonly description: string;
}

interface RawCatalog {
  readonly categories: readonly { key: string; label: string; description: string }[];
  readonly checks: readonly GwCheck[];
}

const catalog = rawCatalog as unknown as RawCatalog;

export const GW_AUDIT_CHECKS: readonly GwCheck[] = catalog.checks;
export const GW_AUDIT_CHECK_IDS: readonly string[] = catalog.checks.map((c) => c.id);
export const GW_AUDIT_CATEGORIES: readonly GwCategoryDef[] = catalog.categories.map((c) => ({
  key: c.key as GwCheckCategory,
  label: c.label,
  description: c.description,
}));
